import React from 'react';
import StrategyBuilder from '../components/StrategyBuilder';

export default function StrategyBuilderPage(props) {
  return (
    <StrategyBuilder {...props} />
  );
}
